import type { InsightsTab } from "./InsightsPanel";

/**
 * Qual aba vale, dado o que o usuário escolheu e o que está publicado.
 *
 * A aba escolhida fica em `localStorage` e sobrevive ao deploy que esconde o
 * assistente: sem esta função, quem tinha `"assistente"` guardado abriria um
 * chat cujas rotas respondem 403. A preferência não é apagada de propósito —
 * quando o assistente for publicado, ela volta a valer.
 */
export function effectiveInsightsTab(
  chosen: InsightsTab,
  assistantEnabled: boolean
): InsightsTab {
  if (assistantEnabled) return chosen;
  return "relatorios";
}
